import { z } from "zod";
/** The document types a channel's file intake takes from email, as the Gmail document intake does. */
export const EMAIL_ATTACHMENT_MIME_TYPES = ["application/pdf", "image/jpeg", "image/png", "image/webp"];
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/u, "Use YYYY-MM-DD.");
/** The run's own synced Gmail, searched for messages that carry a document attachment. */
export const findEmailAttachmentsCommandInputSchema = z.object({
    query: z.string().trim().min(1).max(200).optional(),
    since: isoDate.optional(),
    until: isoDate.optional(),
    limit: z.number().int().min(1).max(25).default(10),
}).strict();
/** Chosen attachments from the run's own Gmail, added to a channel as uploaded files. */
export const addEmailAttachmentsCommandInputSchema = z.object({
    channelId: z.string().trim().min(1).max(200),
    items: z.array(z.object({
        messageId: z.string().trim().min(1).max(200),
        // Omitted: every document attachment on the message.
        attachmentKeys: z.array(z.string().trim().min(1).max(100)).min(1).max(20).optional(),
    }).strict()).min(1).max(10),
}).strict();
const emailAttachmentSchema = z.object({
    key: z.string(), filename: z.string(), mimeType: z.string(), size: z.number().int().nonnegative(),
}).strict();
export const emailAttachmentMessageSchema = z.object({
    messageId: z.string(),
    from: z.string().nullable(),
    subject: z.string().nullable(),
    receivedAt: z.string().nullable(),
    attachments: z.array(emailAttachmentSchema),
}).strict();
export const emailAttachmentSearchResultSchema = z.object({
    messages: z.array(emailAttachmentMessageSchema),
    hasMore: z.boolean(),
}).strict();
/**
 * A workflow run a document started, which its progress route follows; `taskRunId` is null when the workflow could
 * not start now, as its trigger records.
 */
export const emailAttachmentWorkflowRunSchema = z.object({
    workflowId: z.string(), workflowTitle: z.string(), taskRunId: z.string().nullable(), itemIds: z.array(z.string()),
}).strict();
export const emailAttachmentAddOutcomeSchema = z.object({
    messageId: z.string(),
    attachmentKey: z.string().nullable(),
    filename: z.string().nullable(),
    status: z.enum(["added", "already_added", "not_found", "failed"]),
    fileId: z.string().optional(),
    // The runs the channel's workflows started from this file; empty when no workflow takes uploads there.
    workflowRuns: z.array(emailAttachmentWorkflowRunSchema).optional(),
    reason: z.string().optional(),
}).strict();
export const emailAttachmentAddResultSchema = z.object({
    outcomes: z.array(emailAttachmentAddOutcomeSchema),
}).strict();
